import './TypeLabel.scss';

export { default } from './TypeLabel';
